import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import '../McmvForm.css';

interface LoginFormProps {
  onShowLogin: () => void;
  onShowRegister: () => void;
  onShowConsulta: () => void;
  onShowHome?: () => void;
  onBackToLogin?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onShowLogin, onShowRegister, onShowConsulta, onShowHome, onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const result = await login(email, password);
    if (!result.success) {
      setError(result.message || 'Email ou senha inválidos');
    }
    setIsLoading(false);
  };

  return (
    <div className="mcmv-form-container">
      <div className="form-header">
        <div className="header-logos-grid">
          <div className="logo-cell left">
            <img
              src="/images/logo-prefeitura.png"
              alt="Prefeitura de José de Freitas"
              className="header-logo"
            />
          </div>
          <div className="logo-cell center">
            <img
              src="/images/logo-mcmv.png"
              alt="Governo Federal"
              className="header-logo"
            />
          </div>
          <div className="logo-cell right">
            <img
              src="/images/logo-secretaria.jpg"
              alt="Secretaria Municipal de Assistência Social e Cidadania"
              className="header-logo"
            />
          </div>
        </div>
       </div>
        <div className="hero-actions">
            <button
              className="btn btn-primary"
              onClick={() => (onShowHome ? onShowHome() : (onBackToLogin ? onBackToLogin() : onShowLogin()))}
            >
              Início
            </button>
          </div>

      <div className="login-layout">
        {/* Coluna da Esquerda - Formulário de Login */}
        <div className="login-form-section">
          <form onSubmit={handleSubmit} className="form-step">
            <h2>Login</h2>
            
            {error && <div className="error-message">{error}</div>}
            
            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Senha *</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-navigation">
              <button 
                type="submit" 
                disabled={isLoading} 
                className={`btn btn-primary ${isLoading ? 'btn-loading' : ''}`}
              >
                {isLoading ? 'Entrando...' : 'Entrar'}
              </button>
            </div>
          </form>
        </div>

        {/* Coluna da Direita - Links de Cadastro e Consulta */}
        <div className="login-info-section">
          <div className="info-card">
            <div className="register-section">
              <h3>Não tem uma conta?</h3>
              <p>Crie sua conta para se inscrever no programa Minha Casa Minha Vida</p>
              <button 
                type="button" 
                onClick={onShowRegister}
                className="btn btn-outline"
              >
                Cadastrar-se
              </button>
            </div>
            
            <div className="divider"></div>
            
            <div className="consulta-section">
              <h3>Já tem uma inscrição?</h3>
              <p>Consulte o status da sua inscrição usando o número de inscrição</p>
              <button 
                type="button" 
                onClick={onShowConsulta}
                className="btn btn-outline-success"
              >
                Consultar/Recurso Inscrição
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;